<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="大区名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.name" placeholder="请输入大区名称">
						</el-input>
					</el-form-item>
				
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<!-- <el-button type="primary" @click="addCarousel">新增</el-button> -->
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<!-- <el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="300px">
						<el-form-item label="账号">
							<span>{{ props.row.username }}</span>
						</el-form-item>
						<el-form-item label="实名">
							<span>{{ props.row.realname?props.row.realname:'无' }}</span>
						</el-form-item>
						
					
						<el-form-item label="邀请码">
							<span>{{ props.row.invitationCode }}</span>
						</el-form-item>
						<el-form-item label="直推人数(有效)" width="180">
							<span>{{ props.row.inviterCount+"("+props.row.inviterCount+")" }}</span>
						</el-form-item>
						<el-form-item label="邀请人id">
							<span>{{ props.row.inviterUserId }}</span>
						</el-form-item>
						<el-form-item label="邀请人账号">
							<span>{{ props.row.invName }}</span>
						</el-form-item>
						<el-form-item label="邀请人昵称">
							<span>{{ props.row.invNickName }}</span>
						</el-form-item>
						<el-form-item label="邀请人手机号">
							<span>{{ props.row.invPhone }}</span>
						</el-form-item>
						
					</el-form>
				</template>
			</el-table-column> -->
			<el-table-column prop="id" label="ID" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="url" label="大区logo" align="center" >
				<template slot-scope="scope">
					<img :src="scope.row.url" style="width: 50px;height: 50px;border-radius: 50%;" />
				</template>
			</el-table-column>
			<el-table-column prop="name" label="大区名称" align="center" >
			
			</el-table-column>
			<el-table-column prop="userName" label="负责人" align="center" >
			
			</el-table-column>
			
			<el-table-column prop="status" label="是否显示" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<span v-if="scope.row.status==true">是</span>
					<span v-if="scope.row.status==false">否</span>

				</template>
			</el-table-column>
		
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="操作"  fixed="right" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button v-if="scope.row.status" size="small" type="text" @click="status(scope.row.id,'1')" style="color: red;">禁用</el-button>
					<el-button v-else size="small" type="text" @click="status(scope.row.id,'2')">启用</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		
		<!-- 编辑修改 -->
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					
					<el-form-item label="大区名称">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.name" auto-complete="off"
							placeholder="请输入大区名称" />
					</el-form-item>
					<el-form-item label="负责人ID">
						<el-input type="number" style="width: 200px;" v-model="storeGoodsInfo.userId"
							auto-complete="off" placeholder="请输入负责人ID" />
					</el-form-item>
				
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<el-form-item label="大区logo(限制一张)" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<el-span>尺寸建议（42*42px）</el-span></br>
				
						
					</el-form-item>
					
				</div>
				<el-upload style="text-align: left;" :action="httpUrl1" list-type="picture-card" :on-preview="handlePictureCardPreview1"
					:on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" multiple :limit="1"
					:on-success="onSuccess1">
					<i class="el-icon-plus"></i>
				</el-upload>
					<el-button type="primary" @click="submitClick" style="margin-top: 100px;">提交</el-button>

				</el-form>
				
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%"  class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('shoparea');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				sliderlist:{},
				expressList: [],
				orderInfo: {},
				storeGoodsInfo: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				dialogVisibleImg:false,
		
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				}
			}
		},
		methods: {
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			onSuccess(response, file, fileList) {
				// console.log(file,urls,fileList)
				this.storeGoodsInfo.bigPic=file.response.message
				
			},
			onSuccess1(response, file, fileList1) {
				
				this.storeGoodsInfo.url=file.response.message
					
			},
			handleRemove(file, fileList) {
			
					this.storeGoodsInfo.bigPic=''
		
			
			},
			handleRemove1(file, fileList) {
			
					this.storeGoodsInfo.url=''
			
			
			},
			handlePictureCardPreview(file) {
				// console.log(file)
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			handlePictureCardPreview1(file) {
				// console.log(file)
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			lookDt(item){
			// console.log(item)
			this.dialogImageUrl = item;
			this.dialogVisibleImg = true;
			},
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			addDialogClose() {
				// console.log('aaa')

				this.storeGoodsInfo = {}
			},
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					
				
					 name:this.orderInfo.name
					// name:this.orderInfo.name
				}
				this.$api.shoparea(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.fileList = [];
				this.fileList1 = [];
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
			
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.pmsbrdadd(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.fileList = [];
				this.fileList1 = [];
				// console.log(e)
				this.$api.shopareaid(e).then((res) => {
					// console.log(res.data);
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data
					
						
						urls=res.data.url
						// console.log(urls)
					
						if(res.data.lurl!=''){
							this.fileList1.push({
								
								url:res.data.url
							})
						}
						this.dialogVisibleSwipers = true
				
					}
				})
				
			},
			status(id,s){
					if (s == 1) {
						var str = "此操作将禁用该大区, 是否继续?"
					} else {
						var str = "此操作将启用该大区, 是否继续?"
					}
					this.$confirm(str, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api.statusshoparea(id).then((res) => {
							if (res.state == 'success') {
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.pmsbrdselect();
							} else {
								this.$message.error(res.message);
							}
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				
				
			},
			// 编辑修改提交
			submitClick() {
				// console.log(urls)
				let data ={
					"id": this.storeGoodsInfo.id,
					"name": this.storeGoodsInfo.name,
					"userId": this.storeGoodsInfo.userId,
					"url": this.storeGoodsInfo.url,
				}
			
				this.$api.editshoparea(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwipers = false
						this.pmsbrdselect();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},
	
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			this.pmsbrdselect()
		
		}
	}
</script>

<style>

</style>
